import TimetableFlatContainer from './TimetableFlatContainer'

export default TimetableFlatContainer
